import { ReactiveControllerHost } from 'lit';
import { isEqual } from 'lodash-es';
import { PersistedReduxController } from '../../common/redux/controllers/persisted-redux-controller';
import { RootState, persistor, store, slices, selectors } from '../redux/store';

export class SubscriptionController extends PersistedReduxController<RootState>  {

  constructor(host: ReactiveControllerHost) {
    super(host, store, persistor);
  }

  get subscriptionState() {
    return this.state[slices.subscription.name];
  }

  get hasSubscription() {
    return selectors.subscription.hasSubscription(this.subscriptionState);
  }

  get isWaitingForPayment() {
    return selectors.subscription.isWaitingForPayment(this.subscriptionState);
  }

  get showNotification() {
    return selectors.subscription.showNotification(this.subscriptionState);
  }

  get isActive() {
    return selectors.subscription.isActive(this.subscriptionState);
  }

  get isExpired() {
    return selectors.subscription.isExpired(this.subscriptionState);
  }

  get isCancelled() {
    return selectors.subscription.isCancelled(this.subscriptionState);
  }

  get isPremiumActive() {
    return this.isActive || this.isCancelled;
  }

  override stateChanged(state: RootState, forceUpdate: boolean): void {
    if (forceUpdate || !isEqual(state[slices.subscription.name], this.subscriptionState)) {
      this.updateState(state);
      this.host.requestUpdate();
    }
  }
}
